import { Pipe, PipeTransform } from '@angular/core';
import { SortieDto } from '@flyfreely-portal-ui/flyfreely';
import * as moment from 'moment';
import { FlightLogFileWithRpa } from '../mission-flight-logs.directive';

/**
 * Determines whether an unassigned flight log's recorded time (and, if set,
 * RPA) overlaps with an existing flight (sortie) on the mission, so it can
 * be flagged in the UI as a likely candidate for assignment.
 */
@Pipe({
    name: 'matchesExistingFlight'
})
export class MatchesExistingFlightPipe implements PipeTransform {
    transform(log: FlightLogFileWithRpa, sorties: SortieDto[]): boolean {
        const logStart = log?.summary?.startTime;
        const logEnd = log?.summary?.endTime;
        if (logStart == null || logEnd == null || sorties == null) {
            return false;
        }

        return sorties.some(sortie => {
            if (sortie.craftId != null && sortie.craftId !== log.rpaId) {
                return false;
            }
            const sortieStart =
                sortie.durationSource === SortieDto.DurationSource.MANUAL
                    ? sortie.manualStartTime
                    : sortie.startTime ?? sortie.recordedStartTime;
            const sortieEnd =
                sortie.durationSource === SortieDto.DurationSource.MANUAL
                    ? moment(sortie.manualStartTime)
                          .add(sortie.manualDuration, 'seconds')
                          .toISOString()
                    : sortie.startTime ?? sortie.recordedStartTime;
            if (sortieStart == null || sortieEnd == null) {
                return false;
            }
            return (
                moment(logStart).isBefore(sortieEnd) &&
                moment(logEnd).isAfter(sortieStart)
            );
        });
    }
}
